import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChartIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "#fbfbfb",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M4.2002 8.81177H19.2002V11.2118H4.2002V8.81177Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M4.2002 4.83374H15.3002V7.23374H4.2002V4.83374Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M4.2002 12.7898H7.8002V15.1898H4.2002V12.7898Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M4.2002 16.7676H12.0002V19.1676H4.2002V16.7676Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M20.7 21H3.3C3.22044 21 3.14413 20.9684 3.08787 20.9121C3.03161 20.8559 3 20.7796 3 20.7V3.3C3 3.22044 3.03161 3.14413 3.08787 3.08787C3.14413 3.03161 3.22044 3 3.3 3C3.37956 3 3.45587 3.03161 3.51213 3.08787C3.56839 3.14413 3.6 3.22044 3.6 3.3V20.4H20.7C20.7796 20.4 20.8559 20.4316 20.9121 20.4879C20.9684 20.5441 21 20.6204 21 20.7C21 20.7796 20.9684 20.8559 20.9121 20.9121C20.8559 20.9684 20.7796 21 20.7 21Z" })
	]
});
export { SvgChartIcon as ReactComponent };
